import { useMedia } from 'react-use';

import { breakpoints } from '#src/style/mediaQuery.ts';

export const useIsMobile = () =>
  useMedia(`(max-width: ${breakpoints.mobile}px)`);
